import { useMutation, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import { downloadBase64Pdf } from '@/utils/pdfDownload';
import type {
  GetArCustomAgingInput,
  GetArCustomAgingResponse,
  ArCustomAgingCustomerRow,
  ArCustomAgingTotals,
  ArInvoiceListItem,
} from '@erp/rpc';

export function useArCustomAging(filters: GetArCustomAgingInput) {
  const query = useQuery(
    orpc.accountsReceivable.arCustomAging.get.queryOptions({ input: filters }),
  );

  const customers = query.data?.customers ?? [];
  const totals = query.data?.totals ?? null;
  const invoices = query.data?.invoices ?? [];

  return {
    ...query,
    customers,
    totals,
    invoices,
  } satisfies typeof query & {
    data?: GetArCustomAgingResponse;
    customers: ArCustomAgingCustomerRow[];
    totals: ArCustomAgingTotals | null;
    invoices: ArInvoiceListItem[];
  };
}

/**
 * Mutation hook that generates an aging report PDF from the current filters,
 * decodes the base64 response, and triggers a browser download.
 */
export function useDownloadArAgingPdf() {
  return useMutation(
    orpc.accountsReceivable.arCustomAging.downloadPdf.mutationOptions({
      onSuccess: (data) => downloadBase64Pdf(data.pdf, data.filename),
    }),
  );
}
